import InfoMessage from "app/components/InfoMessage/InfoMessage";
import { PublicViewInfoMessageTimeout } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import { Component } from "react";
import {
  IconClock,
  IconDollarBlue,
  IconFavorite,
  IconGraph,
} from "../../../../../../../../../../components/Icon/Icon";
import type { EventType } from "../../../../../../../../../../types/eventType";
import "./ModalEventIcons.scss";
type Props = {
  event: EventType;
  onClickPositionMatrix: Function;
  onClickGraph: Function;
  toggleAddRemoveToFavorites: Function;
};
type State = {
  favouriteSelected: boolean;
  toggleAddRemoveToFavorites: (...args: Array<any>) => any;
  addRemoveFavourite: (...args: Array<any>) => any;
  infoMessageFavourites: boolean;
  infoMessageMarketGraph: boolean;
};

class ModalEventIcons extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      favouriteSelected: this.props.event.favourite,
      infoMessageFavourites: false,
      infoMessageMarketGraph: false,
    };
  }

  // hightlight add/remove favourite icon at component level
  // currently performance too slow waiting on API response
  addRemoveFavourite = (eventId: string) => {
    this.setState({
      favouriteSelected: !this.state.favouriteSelected,
    });
    this.props.toggleAddRemoveToFavorites(eventId);
  };
  // adding to stop unnecessary renders
  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.event.favourite !== this.props.event.favourite) {
      this.setState({
        favouriteSelected: this.props.event.favourite,
      });
    }
  };

  showHelpWidgetForFavourites = () => {
    this.setState({
      infoMessageFavourites: true,
    });
  };

  hideHelpWidgetForFavourites = () => {
    setTimeout(() => {
      this.setState({
        infoMessageFavourites: false,
      });
    }, PublicViewInfoMessageTimeout.infoMessageTimeout);
  };

  showMarketGraphHelpWidget = () => {
    this.setState({
      infoMessageMarketGraph: true,
    });
  };

  hideMarketGraphHelpWidget = () => {
    setTimeout(() => {
      this.setState({
        infoMessageMarketGraph: false,
      });
    }, PublicViewInfoMessageTimeout.infoMessageTimeout);
  };

  render() {
    let { event, onClickPositionMatrix, onClickGraph } = this.props;

    let liveEvents =
      event !== undefined && event["allowLiveBetting"] ? (
        <span className="clock-icon">
          <IconClock className="icon-desktop--inactive asian-event__icon asian-event__event-clock-icon" />
        </span>
      ) : (
        <span className="deadball__icon"></span>
      );
    return (
      <div className="unsummarized-markets-screen__icons">
        <div className="unsummarized-markets-screen__icons-col">
          {liveEvents}
        </div>
        <div
          className={`unsummarized-markets-screen__icons-col `}
          onClick={() => isPublicView() && this.showHelpWidgetForFavourites()}
          onPointerLeave={() =>
            isPublicView() && this.hideHelpWidgetForFavourites()
          }
        >
          {this.state.infoMessageFavourites && (
            <InfoMessage message={"public-view-login-to-action"} />
          )}
          <span
            className={`favourites-icon ${isPublicView() ? "hidden" : ""}`}
            onClick={() => {
              !isPublicView() && this.addRemoveFavourite(event.id);
            }}
          >
            <IconFavorite
              className={`unsummarized-market.unsummarized-markets-modal__market-types .add-market-detailss-screen__event-favorite-icon icon--${
                this.state.favouriteSelected === true ? "active" : ""
              }`}
            />
          </span>
        </div>
        <div className="unsummarized-markets-screen__icons-col">
          {event.hasBetsOnEvent && (
            <span
              className="dollar-icon"
              onClick={() => {
                onClickPositionMatrix(event);
              }}
            >
              <IconDollarBlue className="icon-desktop--inactive unsummarized-markets-screen__icon" />
            </span>
          )}
        </div>
        <div
          className={`unsummarized-markets-screen__icons-col `}
          onClick={() => isPublicView() && this.showMarketGraphHelpWidget()}
          onPointerLeave={() =>
            isPublicView() && this.hideMarketGraphHelpWidget()
          }
        >
          {" "}
          {this.state.infoMessageMarketGraph && (
            <InfoMessage message={"public-view-login-to-action"} />
          )}
          {event["numberOfMarkets"] > 0 && (
            <span
              className={`graph-icon ${isPublicView() ? "hidden" : ""}`}
              onClick={() => {
                !isPublicView() && onClickGraph(event);
              }}
            >
              <IconGraph className="unsummarized-markets-screen__icon unsummarized-markets-screen__icon--graph test" />
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default ModalEventIcons;
